import { createPinia } from 'pinia';
import type { Router } from 'vue-router';
import { defineStore } from '#q-app/wrappers';
import { PiniaColada } from '@pinia/colada';

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
    readonly router: Router;
  }
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default defineStore((/* { ssrContext } */) => {
  const pinia = createPinia();

  let coladaInstalled = false;
  pinia.use(({ app }) => {
    if (!coladaInstalled) {
      coladaInstalled = true;
      app.use(PiniaColada);
    }
  });

  return pinia;
});
